import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import NavBar from '../components/NavBar/NavBar';
import Footer from '../components/Footer/Footer';
import PaymentErrorHandler from '../components/PaymentErrorHandler/PaymentErrorHandler';

const PaymentError: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [errorMessage, setErrorMessage] = useState<string>('Payment failed');
  const [paymentType, setPaymentType] = useState<string>('champion');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const message = searchParams.get('message');
    const type = searchParams.get('type');
    
    if (message) {
      setErrorMessage(decodeURIComponent(message));
    }
    if (type) {
      setPaymentType(type);
    }
    setLoading(false);
  }, [searchParams]);

  const handleRetryPayment = () => {
    // 根据支付类型返回对应页面重新发起支付
    if (paymentType === 'karma') {
      navigate('/user-center?tab=karma');
    } else {
      // Champion 支付 - 返回小说页面
      const novelId = localStorage.getItem('currentNovelId') || '7';
      navigate(`/book/${novelId}`);
    }
  };

  const handleReturnToHome = () => {
    navigate('/');
  };

  if (loading) {
    return (
      <div style={{ background: '#18191A', minHeight: '100vh', color: '#fff', fontFamily: 'inherit' }}>
        <NavBar />
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '24px', marginBottom: '16px' }}>⏳</div>
            <div>Processing payment result...</div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div style={{ background: '#18191A', minHeight: '100vh', color: '#fff', fontFamily: 'inherit' }}>
      <NavBar />
      <PaymentErrorHandler 
        error={errorMessage}
        onRetry={handleRetryPayment}
        onCancel={handleReturnToHome}
      />
      <Footer />
    </div>
  );
};

export default PaymentError;
